export enum MfaType {
    SMS = "sms",
    AuthenticatorApp = "authenticator-app"
  }
  